export const accordion = {
    init: () => {
        const $ = jQuery;

        const accordions = $('.accordion-item');

        if (accordions.length === 0) {
            return false;
        }

        $(accordions).each((i, accordion) => {
            const header = $(accordion).find('.accordion-header');
            const content = $(accordion).find('.accordion-content');
            const icons = $(accordion).find('.icons-wrapper svg');

            header.on('click', () => {
                icons.toggle();
                content.slideToggle();
            });
        });
    }
}